function ClientPrivacyPage() {
  return (
    <main
      className="min-h-screen px-6 py-8 md:px-10 md:py-10"
      style={{
        background:
          "radial-gradient(circle at 8% 0%, #dcfce7 0, transparent 30%), radial-gradient(circle at 100% 10%, #dbeafe 0, transparent 34%), linear-gradient(160deg, #f8fafc 0%, #eef2ff 100%)",
      }}
    >
      <div className="mx-auto w-full max-w-[980px]">
        <section className="rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <p className="m-0 inline-block rounded-full bg-[#111827] px-3 py-1 text-xs font-bold tracking-[0.08em] text-white">
            PRIVACY POLICY
          </p>
          <h1 className="mt-3 text-[clamp(24px,4.5vw,34px)] font-semibold leading-tight tracking-[-0.03em] text-[#0f172a]">
            개인정보 처리방침
          </h1>
          <p className="mt-2 text-xs text-[#667085]">
            시행일: 2026-03-09 | 버전: v1.1
          </p>
        </section>

        <section className="mt-6 space-y-4 rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 text-sm leading-7 text-[#344054] shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              1. 수집하는 개인정보 항목
            </h2>
            <p className="mt-2">
              운영자는 서비스 제공을 위해 다음 정보를 수집할 수 있습니다.
            </p>
            <p className="mt-1">
              이메일 또는 소셜 계정 정보(카카오/애플 계정 식별값, 이메일(제공
              시), 닉네임), 서비스 프로필 정보, 팀/일정/투표/라인업/출석 관련
              이용자 입력 정보, 출석 체크 기능 사용 시 위치정보(위도/경도 또는
              위치 권한 기반 정보), 디바이스/로그 정보(IP, 브라우저 정보,
              접속기록), 푸시 토큰, 선택 동의한 마케팅 수신 여부
            </p>
            <p className="mt-1">
              애플 로그인 사용 시 이용자가 &quot;이메일 가리기&quot;를 선택하면
              Apple Private Relay 주소가 전달될 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              2. 개인정보 수집 방법
            </h2>
            <p className="mt-2">
              이메일 로그인/회원가입, 카카오 OAuth 로그인, 애플 OAuth 로그인,
              이용자의 직접 입력, 서비스 이용 과정에서 자동 생성되는 로그,
              모바일 앱(WebView) 연동 과정에서 수집되는 푸시 토큰을 통해
              정보를 수집합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              3. 개인정보 이용 목적
            </h2>
            <p className="mt-2">
              운영자는 수집한 정보를 다음 목적에 사용합니다.
            </p>
            <p className="mt-1">
              회원 식별 및 인증, 팀 운영 기능 제공, 일정/투표/가입 신청 알림
              발송, 투표 독촉/출석 체크 기능 제공, 서비스 품질 개선, 부정 이용
              방지 및 보안 대응, 출석 체크 및 위치 기반 경기장 도착 확인,
              선택 동의한 마케팅 정보 안내
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              4. 개인정보 보유 및 이용 기간
            </h2>
            <p className="mt-2">
              원칙적으로 회원 탈퇴 시 개인정보를 지체 없이 파기합니다. 다만 관련
              법령에 따라 보존이 필요한 경우 해당 기간 동안 분리 보관 후
              파기합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              5. 개인정보 제3자 제공
            </h2>
            <p className="mt-2">
              운영자는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
              단, 이용자 동의 또는 법령상 요구가 있는 경우에 한해 제공합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              6. 개인정보 처리 위탁 및 국외 이전
            </h2>
            <p className="mt-2">
              서비스 제공을 위해 클라우드/인프라 사업자를 사용할 수 있으며, 이
              과정에서 데이터가 국내외 서버에서 처리될 수 있습니다.
            </p>
            <p className="mt-1">
              예시: Kakao(인증), AWS(S3/서버 인프라), Vercel(프론트 호스팅)
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              7. 위치정보 처리 및 이용 제한
            </h2>
            <p className="mt-2">
              위치정보는 출석 체크 등 기능 제공 목적에서만 사용하며, 이용자는 OS
              권한 설정 또는 앱 설정을 통해 위치 권한을 허용/철회할 수 있습니다.
              위치 권한을 거부하면 일부 기능이 제한될 수 있으며, 서비스는
              출석체크 시 일정 위치 기준 반경 조건(예: 200m)을 확인할 수
              있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              8. 이용자의 권리 및 행사 방법
            </h2>
            <p className="mt-2">
              이용자는 본인의 개인정보에 대해 열람, 정정, 삭제, 처리정지를
              요청할 수 있으며 회원탈퇴를 통해 동의를 철회할 수 있습니다. 또한
              마케팅 수신 동의(선택)는 서비스 설정 화면에서 언제든지 변경할 수
              있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              9. 개인정보 파기 절차 및 방법
            </h2>
            <p className="mt-2">
              파기 사유가 발생한 개인정보는 복구가 불가능한 방법으로 안전하게
              삭제합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              10. 개인정보 안전성 확보 조치
            </h2>
            <p className="mt-2">
              접근권한 관리, 인증정보 보호, 보안 업데이트 적용, 로그 모니터링 등
              기술적/관리적 보호조치를 시행합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              11. 개인정보 관련 문의
            </h2>
            <p className="mt-2">문의 이메일: admin@ahshoot.kr</p>
          </article>

          <article className="rounded-xl border border-[#eaecf0] bg-[#f8fafc] px-4 py-3 text-xs leading-6 text-[#667085]">
            본 방침은 서비스 운영 과정에서 변경될 수 있으며, 중요한 변경 시
            서비스 내 공지합니다.
          </article>
        </section>
      </div>
    </main>
  );
}

export default ClientPrivacyPage;
